export default {
  appConfig: {
    baseApiUrl: "/globus/",
  },
  settings: {
    module: "module_globus",
    path: "/ner-testing",
  }
};
